/* import __COLOCATED_TEMPLATE__ from './edit-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();